import { NotNull } from '../types/utility';

// empty basics
export const EMPTY_ARR: any[] = Object.freeze([]) as unknown as any[];
export const EMPTY_OBJ: Record<string, any> = Object.freeze({});

// A Set needs more than Object.freeze. add/delete/clear write to internal slots
// rather than to properties, so a frozen Set accepts them silently: freezing
// alone would not have stopped a guarantor's role leaking into this constant
// and out into unrelated records, which is what happened. So the mutators are
// replaced with stubs that throw, and the ReadonlySet type stops a write from
// compiling in the first place.
const rejectEmptySetMutation = (): never => {
  throw new TypeError(
    'EMPTY_SET is a shared frozen constant; construct a new Set() instead of mutating it.',
  );
};

export const EMPTY_SET: ReadonlySet<any> = Object.freeze(
  Object.assign(new Set<any>(), {
    add: rejectEmptySetMutation,
    clear: rejectEmptySetMutation,
    delete: rejectEmptySetMutation,
  }),
);

export const EMPTY_PROMISE = (..._args: any[]): Promise<any> =>
  new Promise((resolve) => {
    window.setTimeout(() => {
      resolve(undefined);
    });
  });
export const EMPTY_UNRESOLVED_PROMISE = (..._args: any[]): Promise<any> =>
  new Promise(() => {
    // empty fn
  });

export const EMPTY_RESOLVED_PROMISE = (): Promise<any> => Promise.resolve();

// empty functions
export const NOOP = (..._args: any[]): any => {
  // empty fn
};
export const FALSE_OP = (..._args: any[]) => false;
export const NULL_OP = (..._args: any[]) => null;
export const TRUE_OP = (..._args: any[]) => true;
export const NOT_NULL: NotNull = 'not-null';
